import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgExtend = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M20.467 1.45a2.829 2.829 0 0 1 2.828 2.83v16.342a2.829 2.829 0 0 1-2.828 2.829H4.124a2.829 2.829 0 0 1-2.829-2.829V4.279a2.829 2.829 0 0 1 2.829-2.828Zm0 1.886H4.124a.943.943 0 0 0-.943.943v16.343c0 .52.422.943.943.943h16.343c.52 0 .943-.422.943-.943V4.279a.943.943 0 0 0-.943-.943ZM5.59 16.034c0-.497.601-.747.953-.395l2.563 2.563a.559.559 0 0 1-.395.953H6.149a.559.559 0 0 1-.558-.558Zm12.455-.395a.559.559 0 0 1 .954.395v2.563c0 .308-.25.558-.559.558H15.88a.559.559 0 0 1-.395-.953Zm.395-9.893c.309 0 .56.25.56.559v2.562a.559.559 0 0 1-.955.395L15.484 6.7a.559.559 0 0 1 .395-.954Zm-9.73 0c.498 0 .748.602.396.954L6.544 9.262a.559.559 0 0 1-.953-.395V6.305c0-.31.25-.56.558-.56Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgExtend)
const Memo = memo(ForwardRef)
export default Memo
